<script>
    export default {
        props: [
            'twoFactorAuthDisableRoute',
            'twoFactorAuthRecoveryCodesRoute',
            'appName',
        ],
        data() {
            return {
                password: '',
                errors: '',
            }
        },
        mounted(){
            $('#twoFactorAuthCheckbox').change( ()=> {
                if(! $('#twoFactorAuthCheckbox').prop('checked')) {
                    $('#twoFactorAuthDisableModal').modal('show')
                }
            })
            $('#twoFactorAuthDisableModal').on('hidden.bs.modal', () => {
                $('#twoFactorAuthCheckbox').bootstrapToggle('on')
            })
        },
        methods: {
            disable2FA(){
                axios.post(this.twoFactorAuthDisableRoute, {
                    password: this.password
                })
                    .then(response => {
                        location.reload()
                    })
                    .catch(error => {
                        this.errors = error.response.data
                    })
            },
            fileDownload(response){
                const url = window.URL.createObjectURL(new Blob([response.data]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', this.appName + '_recovery_codes.txt')
                document.body.appendChild(link)
                link.click()
            },
            downloadRecoveryCodes(){
                axios.get(this.twoFactorAuthRecoveryCodesRoute)
                    .then(response => {
                        this.fileDownload(response)
                    })
                    .catch(error => {
                        this.errors = error.response.data
                    })
            },
            cancel(){
                this.password = ''
                this.errors = ''
            },
            errorsForInput(input){
                if (this.errors.errors && input in this.errors.errors){
                    return this.errors.errors[input][0]
                }
            },
        }
    }
</script>
